export const locationsURL = () => '/locations';
export const cityURL = (state: string, city: string, service = 'storage') =>
  `/locations/${state}/${city}/${service}`;
